import { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

export const ChannelPageTitle = () => {
  const {
    state: { loading },
    actions: pageActions,
  } = usePageContext();

  const { channelId, merchantId } = useParams();

  if (!merchantId) return null;

  const { merchantStructure, loading: merchantStructureLoading } = useGetMerchantStructureById(merchantId);

  const firstMerchantStructureLoad = !merchantStructure && merchantStructureLoading;
  useSetPageLoadingWhenRequesting('MERCHANT_STRUCTURE', [firstMerchantStructureLoad]);

  const title = merchantStructure
    ? MerchantStructureEntity.create({ merchantStructure, channelId })?.getChannel()?.description || ''
    : '';

  useLayoutEffect(() => {
    pageActions.setCustomTitle(title);
  }, [title, loading]);

  return <> </>;
};
